import { useState, useEffect } from "react";
import { auth, db } from "../../../firebaseConfig";
import { collection, addDoc, doc, updateDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./SignIn.css"; // Re-using styles from SignIn

const Welcome = () => {
  const [orgName, setOrgName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const checkExistingOrg = async () => {
      const user = auth.currentUser;
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists() && userDoc.data().organizationId) {
          navigate("/home");
        }
      }
    };
    checkExistingOrg();
  }, [navigate]);

  const handleCreateOrganization = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;

    if (!user || !orgName.trim()) {
      console.error("User not found or organization name is empty.");
      // Optionally: show an error to the user
      return;
    }

    try {
      // 1. Create a new organization in the 'organizations' collection
      const orgRef = await addDoc(collection(db, "organizations"), {
        name: orgName.trim(),
        ownerId: user.uid,
        createdAt: serverTimestamp(),
      });

      // 2. Update the user's document in the 'users' collection
      const userDocRef = doc(db, "users", user.uid);
      await updateDoc(userDocRef, {
        organizationId: orgRef.id,
        role: "admin",
      });

      // 3. Redirect to the dashboard
      navigate("/home");

    } catch (error) {
      console.error("Error creating organization:", error);
      // Optionally: show an error to the user
    }
  };

  return (
    <div className="sign-in-container full-page">
      <form onSubmit={handleCreateOrganization}>
        <h4 className="title">Welcome!</h4>
        <p style={{ textAlign: "center", marginBottom: "20px" }}>
          First, let's create an organization for your team or project.
        </p>
        <input
          className="field"
          type="text"
          value={orgName}
          onChange={(e) => setOrgName(e.target.value)}
          placeholder="Your Organization's Name"
          required
        />
        <button className="button" type="submit">Create Organization</button>
      </form>
      <div style={{ marginTop: "40px", textAlign: "center", padding: "0 20px" }}>
        <h5 className="title" style={{ marginBottom: "10px" }}>
          Joining an Existing Organization?
        </h5>
        <p>If someone invited you, please use the link from your invitation email to join.</p>
      </div>
    </div>
  );
};

export default Welcome;
